import { getValue } from '@ourbranch/lookups';

import { brandName } from 'brand-config';

export const getCarOptions = (quote, includeRentersOption) => {
  const { cars, trailers } = quote || {};
  // Brand+state-aware type resolution (#35836): CFM's R/U codes live in trailerTypeByCarrier,
  // keyed cfm.MO, so resolve with the policy/offer state first — the same source the trailer card
  // uses — and only then the trailer's own garaging state.
  const state = quote?.correctedAddress?.state || quote?.state || null;

  const carOptions = cars?.length
    ? cars.map((car) => ({
        id: car.VIN,
        value: `${car.year} ${car.make} ${car.model}, VIN #${car.VIN}`
      }))
    : [];

  const trailerOptions = trailers?.length
    ? trailers.map((trailer) => ({
        id: trailer.VIN,
        value: `${getValue('trailerType', trailer.type, state || trailer.garageLocation?.state, undefined, brandName)}, VIN #${trailer.VIN}`
      }))
    : [];

  if (includeRentersOption) {
    carOptions.push({
      id: 'renters',
      value: 'Renters Coverage'
    });
  }
  const options = [...carOptions, ...trailerOptions];

  return options;
};
